

import {
  generateId,
  getCookie,
  setCookie,
  getLocalStorage,
  setLocalStorage
} from '../utils/storage';

const VISITOR_KEY = 'twiggy_visitor_id';
const COOKIE_EXPIRY_DAYS = 365;

export class VisitorManager {
  private visitorId: string | null = null;
  private isPersistent = false;

  constructor() {
    this.initVisitor();
  }

  
  private initVisitor(): void {
    
    const stored = getLocalStorage(VISITOR_KEY);
    if (stored) {
      this.visitorId = stored;
      this.isPersistent = true;
      this.syncToCookie();
      return;
    }

    
    const cookieId = getCookie(VISITOR_KEY);
    if (cookieId) {
      this.visitorId = cookieId;
      this.isPersistent = true;
      this.syncToLocalStorage();
      return;
    }

    
    try {
      if (typeof sessionStorage !== 'undefined') {
        const sessionId = sessionStorage.getItem(VISITOR_KEY);
        if (sessionId) {
          this.visitorId = sessionId;
          
          this.save();
          return;
        }
      }
    } catch {
      
    }

    
    this.visitorId = generateId();
    this.save();
  }

  
  getVisitorId(): string {
    if (!this.visitorId) {
      this.initVisitor();
    }
    return this.visitorId!;
  }

  
  setVisitorId(id: string): void {
    this.visitorId = id;
    this.save();
  }

  
  private save(): void {
    const localOk = this.syncToLocalStorage();
    this.syncToCookie();
    this.syncToSessionStorage();
    this.isPersistent = localOk || !!getCookie(VISITOR_KEY);
  }

  
  private syncToLocalStorage(): boolean {
    if (!this.visitorId) return false;
    return setLocalStorage(VISITOR_KEY, this.visitorId);
  }

  
  private syncToCookie(): void {
    if (this.visitorId) {
      setCookie(VISITOR_KEY, this.visitorId, COOKIE_EXPIRY_DAYS);
    }
  }

  
  private syncToSessionStorage(): void {
    if (!this.visitorId) return;
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(VISITOR_KEY, this.visitorId);
      }
    } catch {
      
    }
  }

  
  reset(): void {
    this.visitorId = generateId();
    this.save();
  }

  
  isNew(): boolean {
    return !this.isPersistent;
  }
}
